// Core imports
import * as React from 'react';
import InvoiceService from 'src/services/invoice';
import { downloadFile } from 'src/utils/downloadHelper';
import { IPaySimpleError } from 'src/store/modules/paysimplepayment/reducers';
import LocaleFormating from 'src/translation/localeFormating';

// Components imports
import InvoiceToolbar from '../components/InvoiceToolbar';
import InvoiceFilterBar from '../components/InvoiceFilterBar';

// Models imports
import InvoiceModel from 'src/model/invoice.model';
import DateRangeModel from 'src/model/dateRange.model';
import ArSummaryDesktop from 'src/components/AR-Summary/Desktop';

// Style and misc imports
import './InvoicesDesktop.scss';
import Loader from 'src/components/common/Loader';
import ModalPaymentStatusDesktop from '../components/ModalPaymentStatusDesktop';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';
import {
  sortType,
  orderType,
  invoiceType,
  nardType,
  ordernumberType,
  poType
} from 'src/model/modules/invoices.model';
import DisabledTabs from '../components/InvoiceTabs/index';
import InvoiceTables from 'src/components/TableInvoices';
import TablePaginator from 'src/components/common/TablePagination';

class InvoicesDesktop extends React.Component<any, any> {
  constructor(props: IInvoiceFiltersProps) {
    super(props);
  }

  // private prepareInvoicesNumbers(): string[] {
  //   const invoicesNumber: any[] = [];
  //   this.props.selectedInvoices.map(invoice => {
  //     const isExist = invoicesNumber.filter(
  //       a => a.invoiceNo === invoice.invoiceNumber.toString()
  //     );
  //     if (isExist.length === 0) {
  //       invoicesNumber.push({
  //         invoiceNo: invoice.invoiceNumber.toString(),
  //         invoiceDate: invoice.invoiceDate.toString()
  //       });
  //     }
  //   });
  //   return invoicesNumber;
  // }
  /* 
    downloadInvoices
   */
  // private downloadInvoices = () => {
  //   const { selectedInvoices } = this.props;
  //   const selectedList = this.prepareInvoicesNumbers();
  //   if (selectedInvoices.length !== 0) {
  //     InvoiceService.downloadInvoices(selectedList).then((response: any) => {
  //       if (selectedInvoices.length === 1 || selectedList.length === 1) {
  //         downloadFile(
  //           response.data,
  //           `invoice-${
  //             selectedInvoices[0].invoiceNumber
  //           }-${LocaleFormating.getNowDate('short')}.pdf`
  //         );
  //       } else {
  //         downloadFile(
  //           response.data,
  //           `invoices${LocaleFormating.getNowDate('short')}.zip`
  //         );
  //       }
  //     });
  //   }
  // };

  private getFilteredInvoices = (
    dates: DateRangeModel | null = this.props.datesFilter,
    status: statusType = this.props.statusFilter,
    orderStatus: orderType = this.props.orderFilter,
    invoiceNumber: invoiceType = this.props.invoiceFilter,
    nardaNumber: nardType = this.props.nardFilter,
    orderNumber: ordernumberType = this.props.orderNumberFilter,
    orderReference: poType = this.props.poNumberFilter
  ) => {
    const filters: IFiltersInvoice = {
      dateRange: dates,
      status,
      orderStatus,
      invoiceNumber,
      nardaNumber,
      orderNumber,
      orderReference,
      sort: { ...this.props.sortFilter }
    };
    const pagination: IPaginationInvoice = {
      page: 0
    };

    this.props.getInvoices(filters, pagination);
  };

  public setFilters = (
    statusfilter: any,
    orderfilter: any,
    invoiceFilter: any,
    nardFilter: any,
    orderNumberFilter: any,
    poNumberFilter: any
  ) => {
    if (statusfilter?.length > 0) {
      this.getFilteredInvoices(
        null,
        statusfilter ? statusfilter : null,
        orderfilter ? orderfilter : null
      );
    }
    if (orderfilter?.length > 0) {
      this.getFilteredInvoices(
        null,
        statusfilter ? statusfilter : null,
        orderfilter ? orderfilter : null
      );
    }
    if (invoiceFilter?.length > 0) {
      this.getFilteredInvoices(null, invoiceFilter ? invoiceFilter : null);
    }
    if (nardFilter?.length > 0) {
      this.getFilteredInvoices(null, nardFilter ? nardFilter : null);
    }
    if (orderNumberFilter?.length > 0) {
      this.getFilteredInvoices(
        null,
        orderNumberFilter ? orderNumberFilter : null
      );
    }
    if (poNumberFilter?.length > 0) {
      this.getFilteredInvoices(null, poNumberFilter ? poNumberFilter : null);
    }
  };

  private setDates = (datesRange: any) => {
    this.getFilteredInvoices(
      datesRange,
      this.props.statusFilter ? this.props.statusFilter : null
    );
  };
  public render() {
    const { t } = this.props;
    const sortBy: ISort[] = [
      {
        sortBy: 'invoiceNumber',
        label: t('invoices.filters.invoiceNumber')
      },
      {
        sortBy: 'invoiceDate',
        label: t('invoices.filters.invoiceDate')
      },
      {
        sortBy: 'orderNumber',
        label: t('invoices.filters.orderNumber')
      },
      {
        sortBy: 'description',
        label: t('invoices.filters.description')
      },
      {
        sortBy: 'remainingAmount',
        label: t('invoices.filters.remainingAmount')
      },
      {
        sortBy: 'dueDate',
        label: t('invoices.filters.dueDate')
      },
      {
        sortBy: 'status',
        label: t('invoices.filters.status')
      }
    ];

    return (
      <div className="rp-invoices-desktop">
        <div>
          <DisabledTabs setDates={this.setDates} setFilters={this.setFilters} />
        </div>

        {/* {!this.props.isPendingPayment && this.props.showStatusModal ? (
          <ModalPaymentStatusDesktop
            authorized={this.props.authorized}
            trackingNumber={this.props.trackingNumber}
            errorMessage={this.props.errorMessage}
            closeStatusModal={this.props.closeStatusModal}
          />
        ) : null} */}
        {/* <div className="rp-invoiceDesktop--header-content">
          <ArSummaryDesktop renderColumnType="wide" />
        </div> */}
        {/* <InvoiceFilterBar
          invoicesAreEmpty={this.props.invoiceContent.length === 0}
          selectedInvoices={this.props.selectedInvoices}
        />
        <TablePaginator
          handlePagination={this.props.handlePagination}
          pagination={this.props.pagination}
        />
        <InvoiceToolbar
          onClearClicked={this.props.clearSelectedInvoices}
          selectedInvoices={this.props.selectedInvoices}
          removeInvoiceFromSelected={this.props.removeInvoiceFromSelected}
          onDownloadClicked={() => {
            this.downloadInvoices();
          }}
        /> */}
        {/* <InvoiceTable
           headers={sortBy}
          invoices={this.props.invoiceContent}
          isInvActive={this.props.isInvActive}
          usesSelectOnItems={true}
          selectedInvoices={this.props.selectedInvoices}
          getInvoicesIsPending={this.props.getInvoicesIsPending}
          onInvoiceSelect={(invoice: InvoiceModel) => {
            this.props.setSelectedInvoices(invoice);
          }}
          onInvoiceSelectAll={(invoicesSelected: InvoiceModel[]) => {
            this.props.setSelectedInvoices(invoicesSelected);
          }}
        /> */}
        {/* {this.props.isPendingPayment ? <Loader /> : null} */}
      </div>
    );
  }
}

export default InvoicesDesktop;
interface IInvoiceFiltersProps {
  t: any;
  datesFilter: DateRangeModel;
  statusFilter: statusType;
  orderFilter: orderType;
  invoiceFilter: invoiceType;
  nardFilter: nardType;
  orderNumberFilter: ordernumberType;
  poNumberFilter: poType;
  sortFilter: { type: sortType; order: 'asc' | 'desc' };
  getInvoices(filters: IFiltersInvoice, pagination: IPaginationInvoice): void;
  clearAlert: () => void;
}

interface IInvoicesDesktopProps {
  t: any;
  invoiceContent: InvoiceModel[];
  isInvActive: string[];
  selectedInvoices: InvoiceModel[];
  getInvoicesIsPending: boolean;
  authorized: boolean;
  trackingNumber: string;
  errorMessage: string;
  showStatusModal: boolean;
  isPendingPayment: boolean;
  errorPayment: IPaySimpleError;
  setSelectedInvoices(invoices: InvoiceModel | InvoiceModel[]): void;
  clearSelectedInvoices(): void;
  removeInvoiceFromSelected(invoice: InvoiceModel): void;
  closeStatusModal: () => void;
  handlePagination: (type: any) => void;
  pagination: {
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  };
}

interface ISort {
  sortBy: sortType;
  label: string;
}

type statusType = 'dueToday' | 'pastDue' | 'open' | 'pending' | 'paid' | null;
